<template>
  <!-- 电脑端-pc微端下载 -->
  <a
    id="u_c_UBW523"
    class="normal u_c_UBW523"
    target="_blank"
    data-gtm="gtm-download-pc"
    :href="downloadLink"
    @click="u_c_UBW523_event_UI3524($event)"
  ></a>
</template>
<script>
import { reactive, provide, inject, onMounted, watch, ref, computed } from "vue"
import Language from "@/hooks/language.js"
import Router from "@/hooks/router.js"
import bridge from "@/utils/sdkBridge.js"
import * as request from "@/api/request"
import * as utils from "@/utils"
import * as _ from "lodash"

export default {
  name: "",
  components: {},
  setup() {
    const { curLang, getLangTxt, langData } = Language()
    const routerData = inject("routerData", {})
    const pageData = inject("pageData", {})
    const COMP_DATA_LANG = {
      default: {
        href: "https://gevents.37games.com/exe/dzgkr/dzgkr_install_1.0.0.exe",
      },
      "vi-VN": {
        href: "https://gevents.37games.com/exe/dl3dvn/Đấu La Đại Lục : Hồn Sư Đối Quyết_install_2.0.0.exe",
      },
    }
    const compData = reactive(
      COMP_DATA_LANG[curLang] || COMP_DATA_LANG["vi-VN"] || {}
    )

    const router = Router()

    // 自定义setup - 开始
    const zzyPoint = inject("zzyPoint", () => {})
    const gaClickUpload = inject("gaClickUpload", () => {})
    let urlCid = utils.getUrlParams("cid")
    let urlScid = utils.getUrlParams("scid")
    let urlgclid = utils.getUrlParams("gclid")

    if (urlCid) {
      utils.setCookie("cid", urlCid, 90)
    }

    if (urlScid) {
      utils.setCookie("scid", urlScid, 90)
    }

    if (urlgclid) {
      let gclsrc = utils.getUrlParams("gclsrc")
      if (!gclsrc || gclsrc.indexOf("aw") !== -1) {
        utils.setCookie("gclid", urlgclid, 90)
      }
    }

    let cid = urlCid || utils.getCookie("cid")
    let scid = urlScid || utils.getCookie("scid")
    let gclid = urlgclid || utils.getCookie("gclid")

    const adupload = (uploadParam, md5glicd) => {
      request.getJSON(
        `//${utils.getGapi("passport")}/micro_game/add_adparams`,
        {
          key: md5glicd,
          adParams: window.btoa(uploadParam),
        }
      )
    }

    const h5upload = () => {
      const ajaxHost =
        utils.getMainHost() == "gm99.com"
          ? "h5callback.gm99.com/api/v1/mtw_h5"
          : "h5callback-global.37games.com/api/v1/mglb_h5"
      request.getJSON(`//${ajaxHost}`, {
        apikey:
          utils.getMainHost() == "gm99.com"
            ? "hPZ1JP6RR74pE88jpuPdR5pK6fA9rcoD"
            : "nlXp9o2YfeBKQETB15HJQbvubmQhdNZN",
        gameID:
          utils.getUrlParams("gameID") ||
          utils.getUrlParams("game_id") ||
          utils.getUrlParams("gameId"),
        event: "download",
        ext11: utils.getUrlParams("cid") || 1,
        ext12: encodeURIComponent(utils.getUrlParams("scid")),
        ext22: gclid,
        ext23: utils.getUrlParams("packageName"),
        fbc: utils.getCookie("_fbc"),
        fbp: utils.getCookie("_fbp"),
      })
    }

    const downloadLink = ref(compData.href)
    // pc微端下载的click事件
    const u_c_UBW523_event_UI3524 = async (e) => {
      try {
        let uploadParam = `gclid=${gclid}&cid=${cid}&scid=${scid}&fbp=${utils.getCookie(
          "_fbp"
        )}&fbc=${utils.getCookie("_fbc")}`
        let md5glicd = utils.md5(uploadParam)
        downloadLink.value = compData.href.replace(/.exe$/, `_${md5glicd}.exe`)

        adupload(uploadParam, md5glicd)
        h5upload()
        zzyPoint("gtm-download-pc")

        let gtm_filter_res = utils.getCookie(
          `zz_gtm_filter_${pageData.gameId}_pc`
        )
        if (!gtm_filter_res) {
          gaClickUpload("gtm-click-pc")
          if (pageData.gameId) {
            utils.setCookie(`zz_gtm_filter_${pageData.gameId}_pc`, 1, 30)
          }
        }
        setTimeout(() => {
          pageData.isDownloadExe = true
        }, 1000)
      } catch (error) {
        console.log(error)
      }
    }
    // 自定义setup - 结束
    return {
      u_c_UBW523_event_UI3524,
      downloadLink,
      pageData,
      routerData,
      compData,
      langData,
    }
  },
}
</script>
<style lang="scss" scoped>
.default {
  .u_c_UBW523.normal {
    position: absolute;
    width: 37.96vh;
    height: 8.15vh;
    background-image: url(https://gimages.olgamevn.com/aws_s3/img?s=/platform/one_image/2022/08/16602717425052.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    top: 81.11vh;
    left: 50%;
    transform: translateX(-50%);
    margin-left: 16.3vh;
  }
  .u_c_UBW523.normal:hover {
    cursor: point;
  }
}
.vi-VN {
  .u_c_UBW523.normal {
    position: absolute;
    width: 37.96vh;
    height: 8.15vh;
    background-image: url(https://gimages.olgamevn.com/aws_s3/img?s=/platform/one_image/2022/10/16662596566654.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    top: 81.11vh;
    left: 50%;
    transform: translateX(-50%);
    margin-left: 16.3vh;
  }
  .u_c_UBW523.normal:hover {
    cursor: point;
  }
}
</style>
